function isReactivatable(it) {
    return it.status === "DEACTIVATED" || it.status === "SUSPENDED";
}

skrilla.controller('bettingMarketsCtrl', function ($scope, cacheService, searchService, modalService, envService, racingEventService, adminV2Service) {
    $scope.pageKey = "bettingMarkets";
    $scope.bettingMarkets = cacheService.getObjectOrElse("bettingMarketsTable", []);

    $scope.publishAll = function () {
        modalService.openModal("views/bettingMarkets/publishEventsModal.html", true, 'lg', true, true);
    }
    $scope.recoverAll = function () {
        modalService.openModal("views/bettingMarkets/recoverEventsModal.html", true, 'lg', true, true);
    }
    $scope.updateStreams = function () {
        modalService.confirm("Are you sure you'd like to update streams for all markets?", function () {
            searchService.post("betting/markets/updateStreams", null, "Bet Radar streams updated", true).then(function (response) {
                console.log("Bet radar streams updated")
            })
        });
    }
    $scope.providerConnections = function () {
        modalService.openModal("views/bettingMarkets/providerConnectionModal.html", true, 'lg', true, true);
    }

    $scope.anyActive = function (event) {
        return event.markets.some(it => it.status === "ACTIVE")
    }
    $scope.anyDeactivated = function (event) {
        return event.markets.some(it => isReactivatable(it))
    }
    $scope.deactivate = function (event) {
        cacheService.registerObject("event", event)
        modalService.openModal("views/bettingMarketDetails/updateBetStopModal.html", true, 'lg', false, true, function () {
            $scope.get();
        });
    }
    $scope.reactivate = function (event) {
        modalService.confirm("Are you sure you'd like to reactivate all the deactivated markets on this event (that are on this page)?", function () {
            Promise.all(
                event.markets
                    .filter(it => isReactivatable(it))
                    .map(async it => {
                        const put = searchService.put("betting/markets/" + it.id + "/reactivate", {});
                        await put
                        console.log("Market reactivated", it.id)
                        put
                    })
            ).then((all) => {
                console.log("Markets reactivated", all)
                modalService.dismissAll();
                swal("Success!", `${all.length} Markets Reactivated`, "success");
            });
        });
    }
    $scope.voidSelections = function (event) {
        cacheService.registerObject("bettingEvent", event)
        modalService.openModal("views/bettingMarkets/voidEventMarketSelectionsModal.html", true, 'lg', true, true, function () {
        });
    }

    $scope.isRacingEvent = racingEventService.isRacingEvent

    $scope.openV2 = function (path, id) {
        adminV2Service.openV2(`/${path}/${id}`)
    }

});
